import React from 'react'
import Modal from 'component/modal'
import { usePlan } from './plan.context'
import Api from 'utils/api'
import PlanForm from './PlanForm'

function CreatePlan() {
  const {
    openModal,
    setOpenModal,
    plans,
    setPlans,
    selectedPlan,
    setSelectedPlan,
  } = usePlan()
  
  const isUpdate = Boolean(selectedPlan)

  const onClose = () => {
    setOpenModal(false)
    setSelectedPlan()
  }

  const handleSubmit = async (form, { setSubmitting }) => {
    const payload = { ...form }
    if (isUpdate) {
      payload._id = selectedPlan._id
    }

    const { response } = await Api(`/plans`, isUpdate ? 'put' : 'post', {
      payload,
      notify: true,
    })

    if (response) {
      if (isUpdate) {
        const idx = plans.findIndex((item) => item._id === selectedPlan._id)
        if (idx !== -1) {
          const updatedPlans = [...plans]
          updatedPlans[idx] = response.data
          setPlans(updatedPlans)
        }
      } else {
        setPlans([...plans, response.data])
      }
    }

    setSubmitting(false)
    onClose()
  }

  return (
    <Modal open={openModal} onClose={onClose}>
      <div className='p-6 flex items-center justify-between border-b border-gray-100 mb-6'>
        <h2 className='text-3xl font-black text-gray-900 tracking-tighter'>
          {isUpdate ? 'PLAN CONFIGURATION' : 'SYSTEM PLAN CREATION'}
        </h2>
        <span className='px-4 py-1.5 bg-gray-100 text-gray-500 text-[10px] font-black rounded-lg uppercase tracking-widest'>
          {isUpdate ? 'Edit Logic' : 'New Primitive'}
        </span>
      </div>
      
      <PlanForm 
        initialData={selectedPlan} 
        onSubmit={handleSubmit} 
        onCancel={onClose}
        forceSubscription={null}
      />
    </Modal>
  )
}

export default CreatePlan
